var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.index,
      staticClass: "c-checklist-block-item",
      attrs: { id: _vm.id }
    },
    [
      _c("div", { staticClass: "c-checklist-block-item__step-container" }, [
        _c("div", { staticClass: "c-checklist-block-item__step-icon" }, [
          _c("span", { staticClass: "c-checklist-block__item-step-number" }, [
            _vm._v("\n\t\t\t\t" + _vm._s(_vm.order) + "\n\t\t\t")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-checklist-block-item__content" }, [
        _c("div", { staticClass: "c-checklist-block-item__card" }, [
          _c(
            "div",
            { staticClass: "c-checklist-block-item__card-icon" },
            [_c("v-icon", { attrs: { name: _vm.icon, size: "m" } })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "c-checklist-block-item__card-content" }, [
            _c("div", { staticClass: "c-checklist-block-item__card-header" }, [
              _c("h3", { staticClass: "c-checklist-block-item__card-title" }, [
                _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t\t\t")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "c-checklist-block-item__card-body" }, [
              _c(
                "p",
                { staticClass: "c-checklist-block-item__card-text text" },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.description.length > 139
                          ? _vm.description.substring(0, 139) + "..."
                          : _vm.description
                      ) +
                      "\n\t\t\t\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _vm.linkUrl
                ? _c(
                    "a",
                    {
                      staticClass: "c-checklist-block-item__link-wrapper",
                      attrs: { href: _vm.linkUrl }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "c-checklist-block-item__link-text" },
                        [_vm._v(_vm._s(_vm.linkText))]
                      ),
                      _vm._v(" "),
                      _c("v-icon", {
                        attrs: { name: "icon-chevron", size: "xs" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-checklist-block-item__checkbox" }, [
            _c(
              "button",
              {
                staticClass: "c-checklist-block-item__checkbox-button",
                attrs: {
                  id: _vm.checkBoxName + "-checklist-checkbox-" + _vm.id,
                  checked: _vm.isChecked
                },
                on: { click: _vm.onCheckboxChange }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "c-checklist-block-item__checkbox-icon",
                    class: {
                      "c-checklist-block-item__checkbox-icon--checked":
                        _vm.isChecked
                    },
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24ZM12,1.87A10.13,10.13,0,1,0,22.13,12,10.14,10.14,0,0,0,12,1.87Z"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M10.75,17.12a.77.77,0,0,1-.53-.21L5.87,12.75A.78.78,0,1,1,7,11.63l3.79,3.62,7-7.12a.78.78,0,1,1,1.11,1.09l-7.5,7.67A.79.79,0,0,1,10.75,17.12Z"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }